import React from 'react';
import { InlineViewError } from '../../components/error/InlineViewError';
import { ViewErrorState } from '../../components/error/ViewErrorState';
import { CustomIconWrapper, Loader } from '../../components/loaders/Loader';
import { Spinner } from '../../components/loaders/Spinner';
import { getViewErrorDetail, getViewErrorKind } from './view-error-kind';

export type LoaderData = React.ReactNode | LoaderWithIcon;

type LoaderWithIcon = {
  readonly message: React.ReactNode;
  readonly icon?: React.ReactNode;
};

function isComplexMessage(d: LoaderData): d is LoaderWithIcon {
  return !!d && typeof d === 'object' && 'message' in d;
}

export function ViewLoader(p: { loaderData?: LoaderData }) {
  const { loaderData } = p;

  const message = isComplexMessage(loaderData) ? loaderData.message : loaderData;

  const icon =
    isComplexMessage(loaderData) && loaderData.icon ? (
      <CustomIconWrapper>{loaderData.icon}</CustomIconWrapper>
    ) : (
      <Spinner />
    );

  return <Loader message={message} icon={icon} />;
}

/**
 * Error state for a failed query. The error is classified (missing, forbidden, unreachable,
 * unexpected) so the user gets translated copy and recovery actions; the raw message is kept
 * as a technical detail. `inline` renders a compact label for layouts that cannot host a
 * full centered state.
 */
export function ViewError(p: { error: unknown; inline?: boolean; onRetry?: () => void }) {
  const kind = getViewErrorKind(p.error);
  const detail = getViewErrorDetail(p.error);

  if (p.inline) {
    return <InlineViewError kind={kind} detail={detail} />;
  }

  return <ViewErrorState kind={kind} detail={detail} onRetry={p.onRetry} />;
}
